import { render, staticRenderFns } from "./Hot.vue?vue&type=template&id=6721960c"
import script from "./Hot.vue?vue&type=script&lang=js"
export * from "./Hot.vue?vue&type=script&lang=js"
import style0 from "./Hot.vue?vue&type=style&index=0&id=6721960c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports